import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';

import { startProvAuth } from 'app/store/actions/auth-actions';
import { FetchStatus, ConsentState } from 'app/store/root-types';
import { fetchConsent, updateConsents } from 'app/store/actions/consent-actions';
import { selectCustomerLocation } from 'app/store/actions/user-context-actions';
import { logout } from '../actions/auth-thunks';

const initialState: ConsentState = {
  fetchStatus: FetchStatus.NOT_STARTED,
};

const consentSlice: Slice<ConsentState> = createSlice({
  name: 'consent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(selectCustomerLocation, () => initialState);
    builder.addCase(logout.fulfilled, () => initialState);
    builder.addCase(startProvAuth, () => initialState);
    builder.addCase(fetchConsent.pending, (state) => {
      state.fetchStatus = FetchStatus.PENDING;
    });
    builder.addCase(fetchConsent.fulfilled, (state, action: PayloadAction<MinesiderBackend.CrmUserConsents>) => {
      state.consent = action.payload;
      state.fetchStatus = FetchStatus.FULFILLED;
    });
    builder.addCase(fetchConsent.rejected, (state) => {
      state.fetchStatus = FetchStatus.REJECTED;
    });
    builder.addCase(updateConsents.pending, (state) => {
      state.fetchStatus = FetchStatus.PENDING;
    });
    builder.addCase(updateConsents.fulfilled, (state, action: PayloadAction<MinesiderBackend.CrmUserConsents>) => {
      state.consent = action.payload;
      state.fetchStatus = FetchStatus.FULFILLED;
    });
    builder.addCase(updateConsents.rejected, (state) => {
      state.fetchStatus = FetchStatus.REJECTED;
    });
  },
});

const { reducer } = consentSlice;

export { reducer };
